import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

export const getCurrentUserWorkTimeSaldoInformation = async (
  activeEmployerInfo
) => {
  const apiPath = `work-time-saldo/current-user/saldo-information`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
    activeEmployerInfo,
  });

  const response = await axios(signedRequest);
  return response.data;
};
